import type { EditScannerConfigInputV2, ScannerProfile } from '@rtkwlf/rendall';

import type { ScannerDetailsForm } from '../components/types';

export const prepareUpdateScannerConfigPayload = (
  values: ScannerDetailsForm,
  scannerProfile: ScannerProfile,
): EditScannerConfigInputV2 => {
  const scannerDetails = scannerProfile.scannerDetails;
  return {
    name: values.name || null,
    site: values.site || null,
    hostIden: values.hostIden,
    vulnScan: values.vulnScan,
    cgiScan: values.cgiScan,
    bruteScan: values.bruteScan,
    pingOnly: values.pingOnly,
    hostIdenServers: scannerDetails?.dnsServers ?? [],
    scanExclusionList: scannerDetails?.denyList ?? [],
    portBlockRules: scannerDetails?.portBlockRules ?? [],
    hostIdentificationScanIntensity: values.hostIdentificationScanIntensity,
    hostIdentificationScanPeriod: Number(values.hostIdentificationScanPeriod),
    maxConcurrentVulnerabilityScans: Number(
      values.maxConcurrentVulnerabilityScans,
    ),
  };
};
